import * as braze from "@braze/web-sdk";

// Braze only initialises after advertisement consent, so every method must
// no-op when it hasn't: the Unity bridge calls these regardless of consent.
class BrazeService {
    static initialized = false;

    static init(apiKey, baseUrl) {
        if (BrazeService.initialized) return;

        braze.initialize(apiKey, {
            baseUrl: baseUrl,
            enableLogging: process.env.NODE_ENV !== "production",
            allowUserSuppliedJavascript: true,
            manageServiceWorkerExternally: false,
            safariWebsitePushId: undefined, // Safari push ?
        });

        braze.openSession();

        BrazeService.initialized = true;
        console.log("[BrazeService] Initialized");
    }

    static changeUser(userId) {
        if (!BrazeService.initialized || !userId) return;
        braze.changeUser(userId);
        console.log(`[BrazeService] Changed user to: ${userId}`);

        if (braze.isPushSupported()) {
            braze.requestPushPermission();
        }
    }

    static logCustomEvent(eventName, properties = {}) {
        if (!BrazeService.initialized) return;
        braze.logCustomEvent(eventName, properties);
    }

    static logPurchase(productId, price, currencyCode = "USD", quantity = 1, properties = {}) {
        if (!BrazeService.initialized) return;
        braze.logPurchase(productId, price, currencyCode, quantity, properties);
    }

    static setUserAttribute(key, value) {
        if (!BrazeService.initialized) return;
        const user = braze.getUser();
        if (!user) return;
        user.setCustomUserAttribute(key, value);
    }

    static setEmail(email) {
        if (!BrazeService.initialized) return;
        braze.getUser()?.setEmail(email);
    }

    static setFirstName(name) {
        if (!BrazeService.initialized) return;
        braze.getUser()?.setFirstName(name);
    }

    static setLastName(name) {
        if (!BrazeService.initialized) return;
        braze.getUser()?.setLastName(name);
    }

    static setLanguage(lang) {
        if (!BrazeService.initialized) return;
        braze.getUser()?.setLanguage(lang);
    }

    static setCountry(country) {
        if (!BrazeService.initialized) return;
        braze.getUser()?.setCountry(country);
    }

    static requestPushPermission() {
        if (!BrazeService.initialized) return;
        braze.requestPushPermission();
    }

    static isPushSupported() {
        if (!BrazeService.initialized) return false;
        return braze.isPushSupported();
    }

    static subscribeToInAppMessages(callback) {
        if (!BrazeService.initialized) return;
        braze.subscribeToInAppMessage(callback);
    }

    static openSession() {
        if (!BrazeService.initialized) return;
        braze.openSession();
    }

    static destroy() {
        if (!BrazeService.initialized) return;
        braze.destroy();
        BrazeService.initialized = false;
    }
}

export default BrazeService;